(function($, undefined) {
	
	'use strict';	
	var imagePreviewCtn;

	var storyHovered = function() {
		var t = $(this);
		var imgPath = t.attr('data-image-preview');
		if(!(t.hasClass('active'))) {
			$('.story-list-item').removeClass('active');
			t.addClass('active');
			imagePreviewCtn.css('background-image', 'url("' + imgPath + '")');
		}
	};
	
	
	var checkPreviewImageDocked = function(element, target) {
		if (element.length > 0) {
			var targetTop = target.offset().top;
			var scrollTop = $(window).scrollTop();
			
			if (scrollTop >= targetTop) {
				element.addClass('docked');
				element.css({
					"left": target.offset().left
				});
			}
			else {
				element.removeClass('docked');
				element.removeAttr('style');
			}
		}
	};
	
	var init = function () {
		imagePreviewCtn = $('.stories-image-preview');
		$('.story-list-item').hover(storyHovered);

		//var onloadImgPath = $('.story-list-item.active').attr('data-image-preview');
		//imagePreviewCtn.css('background-image', 'url('+onloadImgPath+')');
		//
		checkPreviewImageDocked($('.stories-image-preview-ctn'), $('.stories-image-preview-wrapper'));
		$(window).scroll(function() {
			checkPreviewImageDocked($('.stories-image-preview-ctn'), $('.stories-image-preview-wrapper'));
		});
		$(window).resize(function() {
			checkPreviewImageDocked($('.stories-image-preview-ctn'), $('.stories-image-preview-wrapper'));
		});
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
